import {
  DEFAULT_EPISODE_DISPLAY,
  EPISODE_FILTER_IDS,
  EPISODE_FILTER_URL_KINDS,
} from "@bastion/episodes";
import { decodeFilterStateFromParams } from "@bastion/list-view";
import type { EpisodeFiltersShape } from "@bastion/assistant";
import { decodeEpisodeDisplayFromParams, migrateLegacyEpisodeParams } from "./episodeSearchParams";
import { flattenEpisodeFiltersForAssistant } from "@bastion/episodes";

/**
 * Parse the current URL search string into the assistant-facing episode filter snapshot.
 * Defaults `current_page` to 1 — callers should merge the live store page when available.
 */
export function readEpisodeFiltersFromSearch(search: string): EpisodeFiltersShape {
  const qs = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(qs);
  migrateLegacyEpisodeParams(params);
  const filterState = decodeFilterStateFromParams(params, EPISODE_FILTER_IDS, EPISODE_FILTER_URL_KINDS);
  const display = { ...DEFAULT_EPISODE_DISPLAY, ...decodeEpisodeDisplayFromParams(params) };
  return flattenEpisodeFiltersForAssistant(filterState, display, 1);
}
